<style type="text/css">
.domain-list .el-table__header-wrapper {
    display: none;
    overflow: initial !important;
}
.el-table .cell {
    text-overflow: unset !important;
}
</style>
<style scoped>
.el-main {
}

.el-button--text {
    background: white;
}

.el-button--text:hover {
    background: white;
}

.notes-box {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
}

.notes-box:hover {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
}

.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}

.content-wrapper .content {
    padding-top: 95px !important;
}

.notes-domain {
    line-height: 1;
    display: block;
}

.slide-fade-enter-active {
    transition: all 3s ease;
}
.slide-fade-leave-active {
    transition: all 8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}

.shadowBox {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
}
.round {
    border-radius: 50%;
}
.el-button--primary > span > a {
    color: #fff;
}
.domain-name {
    display: block;
    line-height: 1;
    font-weight: bold;
    color: #444;
    text-align: left;
}
.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-table {
    font-size: 13.5px;
}

.publisher-name {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}

.dfp-network-alias {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}
.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}
.bucket-list li {
    float: left;
    margin-right: 10px;
}
.bucket-list li:last-child {
    margin-right: 0;
}
.buckets {
    overflow: auto;
}
</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">All Domains</h3>
                    <router-link to="/admin/create-domain/" class="el-button el-button--info pull-right">
                        <i class="el-icon-plus el-icon-left"></i>
                        Create Domain
                    </router-link>
                </div>
                <div class="box-body domain-list">
                    <el-table height="400" v-loading="loading" :data="domains" style="width: 100%; border-spacing: 0">
                        <el-table-column label="" width="50">
                            <template slot-scope="scope">
                                <div class="text-center">
                                    <img class="round" width="30" height="30" :avatar="`${scope.row.name}`" />
                                    <!-- <img class="round" width="30" height="30" :src="`https://${scope.row.name}/favicon.ico`"> -->
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column width="300" label="" prop="name">
                            <template slot-scope="props">
                                <router-link
                                    :to="`${
                                        '/admin/publisher/' + props.row.publisher.uuid + '/domain/edit/' + props.row.id
                                    }`"
                                >
                                    <span class="domain-name">{{ `${props.row.name}` }}</span>
                                    <span class="publisher-name">{{ `${props.row.publisher.name}` }}</span>
                                    <span v-if="props.row.dfp_network != null" class="dfp-network-alias"
                                        >{{ `${props.row.dfp_network.display_name}` }} DFP</span
                                    >
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="Reports" prop="Reports" width="50">
                            <template slot-scope="props">
                                <el-tooltip content="Reports" placement="bottom">
                                    <router-link
                                        :to="`${
                                            '/admin/publisher/' +
                                            props.row.publisher.id +
                                            '/ReportsRevenue/' +
                                            props.row.id
                                        }`"
                                        class="el-button notes-box el-button--text el-button--small forcontract"
                                        style=""
                                    >
                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                    </router-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column width="50">
                            <template slot-scope="props">
                                <el-dropdown class="" trigger="click">
                                    <span class="el-dropdown-link">
                                        <el-badge :value="0" :max="10" class="item">
                                            <el-button
                                                class="notes-box"
                                                type="text"
                                                size="small"
                                                v-clipboard:copy="props.row.site_tag"
                                                v-clipboard:success="onCopy"
                                                v-clipboard:error="onError"
                                            >
                                                <span>
                                                    <svg
                                                        width="17px"
                                                        height="17px"
                                                        aria-hidden="true"
                                                        data-prefix="fal"
                                                        data-icon="copy"
                                                        role="img"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512"
                                                        class="svg-inline--fa fa-copy fa-w-14 fa-2x"
                                                    >
                                                        <path
                                                            fill="currentColor"
                                                            d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
                                                            class=""
                                                        ></path>
                                                    </svg>
                                                </span>
                                            </el-button>
                                        </el-badge>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <ul class="dropdown-menu-devin" style="max-width: 700px !important">
                                            <li class="header" style="margin:5px; padding 0px; font-size: 12px;">
                                                {{ props.row.site_tag ? props.row.site_tag : 'No Script Present.' }}
                                            </li>
                                            <li
                                                class="text-danger"
                                                style="margin-left:20px; padding 0px; font-size: 10px;"
                                            >
                                                <b>copied!</b>
                                            </li>
                                        </ul>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                        <el-table-column width="50">
                            <template slot-scope="props">
                                <router-link :to="`${'/admin/domains/notes/' + props.row.id}`">
                                    <el-button class="notes-box" type="text" size="small">
                                        <span>
                                            <svg
                                                width="17px"
                                                height="17px"
                                                aria-hidden="true"
                                                data-prefix="far"
                                                data-icon="pen-square"
                                                role="img"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 448 512"
                                                class="svg-inline--fa fa-pen-square fa-w-14 fa-2x"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M246.6 177.9l55.5 55.5c2.3 2.3 2.3 6.1 0 8.5L166.4 377.6l-57.1 6.3c-7.6.8-14.1-5.6-13.3-13.3l6.3-57.1L238 177.8c2.4-2.2 6.2-2.2 8.6.1zm98.4-12.8L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                                                    class=""
                                                ></path>
                                            </svg>
                                        </span>
                                    </el-button>
                                </router-link>
                            </template>
                        </el-table-column>

                        <el-table-column>
                            <template slot-scope="props">
                                <div class="buckets">
                                    <ul
                                        class="bucket-list clearfix"
                                        v-bind:style="{
                                            width:
                                                122 *
                                                    ((props.row.buckets && props.row.buckets.length) > 3
                                                        ? props.row.buckets.length
                                                        : 4) +
                                                'px',
                                        }"
                                    >
                                        <li v-for="bucket in props.row.buckets" :key="bucket.id" class="shadowBox">
                                            <router-link
                                                :to="`${
                                                    '/admin/publisher/' +
                                                    props.row.publisher.uuid +
                                                    '/domain/' +
                                                    props.row.id +
                                                    '/buckets/' +
                                                    bucket.id +
                                                    '/'
                                                }`"
                                            >
                                                <span class="">
                                                    <svg
                                                        aria-hidden="true"
                                                        width="12"
                                                        height="12"
                                                        data-prefix="fab"
                                                        data-icon="bitbucket"
                                                        role="img"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 512 512"
                                                        class="svg-inline--fa fa-bitbucket fa-w-16 fa-3x"
                                                    >
                                                        <path
                                                            fill="currentColor"
                                                            d="M23.1 32C14.2 31.9 7 38.9 6.9 47.8c0 .9.1 1.8.2 2.8L74.9 462c1.7 10.4 10.7 18 21.2 18.1h325.1c7.9.1 14.7-5.6 16-13.4l67.8-416c1.4-8.7-4.5-16.9-13.2-18.3-.9-.1-1.8-.2-2.8-.2L23.1 32zm285.3 297.3H204.6l-28.1-146.8h157l-25.1 146.8z"
                                                            class=""
                                                        ></path>
                                                    </svg>
                                                </span>
                                                <span class=""> {{ `${bucket.name}` }}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <infinite-loading
                            slot="append"
                            @infinite="infiniteHandler"
                            force-use-infinite-wrapper=".el-table__body-wrapper"
                        ></infinite-loading>
                    </el-table>
                </div>
                <!-- <infinite-loading slot="append" :distance="1200" @infinite="infiniteHandler" ></infinite-loading>	 -->
            </div>
        </section>

        <transition>
            <router-view></router-view>
        </transition>
    </div>
    <!-- </transition> -->
</template>
<script type="text/javascript">
import axios from 'axios';
import VueRouter from 'vue-router';
import LetterAvatar from '../../../../static/plugins/letterAvatar.js';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import { mapActions } from 'vuex';
import authConfig from '../../../authConfig';

const api = BASE_URL + 'v1/domains/';

export default {
    data() {
        return {
            domains: [],
            current_page: 1,
            bottom: false,
        };
    },
    created: function () {
        console.log('Dashboard created');
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            console.log('User found in localStorage, setting application state.');
            this.$store.dispatch('setUser', user.profile);
            this.$store.dispatch('setToken', user.access_token);
            this.$router.push({ name: 'Domain' }).catch((err) => {
                if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
                    console.error(err, 'err');
                }
            });
            return;
        }

        const userManager = new UserManager({
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            ...authConfig,
        });
        userManager
            .signinRedirectCallback()
            .then((user) => {
                console.log('signinRedirectCallback executed successfully');
                localStorage.setItem('default_auth_token', user.access_token);
                localStorage.setItem('user', JSON.stringify(user));
                this.$store.dispatch('setUser', user.profile);
                this.$store.dispatch('setToken', user.access_token);
                this.$router.push({ name: 'Domain' }).catch((err) => {
                    if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
                        console.error(err, 'err');
                    }
                });
            })
            .catch((error) => {
                console.log('Error executing signinRedirectCallback');
                console.error('Error in signinRedirectCallback:', error);
                this.$router.push({ name: 'Login' });
            });
    },
    methods: {
        ...mapActions(['setUser', 'setToken']),

        infiniteHandler($state) {
            console.log('running infinite handler');
            console.log($state);
            axios
                .get(api, {
                    params: {
                        page: this.current_page,
                    },
                })
                .then(({ data }) => {
                    if (data.length) {
                        this.current_page += 1;
                        this.domains.push(...data);
                        $state.loaded();
                        window.setTimeout(function () {
                            LetterAvatar.transform();
                        });
                    } else {
                        console.log('completed---!!!!!!');
                        $state.complete();
                    }
                })
                .catch((error) => {
                    module.status = error.response.data.status;
                    $state.complete();
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// AllDomain.vue?6302d445